import React, { Component } from 'react';
import TableC from '../../../../basicElement/TableC';
import renderEnhancer from '../../../../shared/renderEnhancer';
import format from '../../../../shared/format';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { pagination, sortParams, searchParams, activeKey, onChange } = this.props;
        const { current, pageSize } = pagination;

        this.setState({ loading: true });
        Fetch.post(API_URL.requestDataAnalysis.queryRefundedInvoiceData, {
            offset: current,
            limit: 10,
            ...sortParams,
            ...searchParams,
            type: activeKey,
        }).then(res => {
            const { datas, totalCount } = res;
            const data = this.getDataSource(datas);
            const len = data.length;
            const pageSize = len <= 11 ? 11 : len;
            pagination.pageSize = pageSize;
            pagination.total = totalCount + (pageSize - 10) * Math.ceil(totalCount / 10);
            onChange({ pagination });
            this.setState({
                data,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const { activeKey } = this.props;
        const columns = [{
            title: '请款单号',
            dataIndex: 'remittanceCode',
            key: 'remittanceCode',
            fixed: 'left',
            width: 100,
            render: renderEnhancer((text, record) => {
                if (text === '合计') return text;
                return <a onClick={() => this.handleClick(record)}>{text}</a>;
            })
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: renderEnhancer(),
        }, {
            title: 'JDE主项目号',
            dataIndex: 'investigationJdeMainCode',
            key: 'investigationJdeMainCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: 'JDE项目号',
            dataIndex: 'investigationJdeContractCode',
            key: 'investigationJdeContractCode',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '客户付款单位',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 160,
            render: renderEnhancer(),
        }, {
            title: '请款笔数',
            dataIndex: 'remittanceNum',
            key: 'remittanceNum',
            width: 100,
            render: renderEnhancer(),
        }, {
            title: '请款节点',
            dataIndex: 'cashReqNode',
            key: 'cashReqNode',
            width: 120,
            render: renderEnhancer((text, record) => {
                const { cashReqNodeType, cashReqNodeNum } = record;
                return text ? `${text}${cashReqNodeType ? cashReqNodeType === 'NNF' ? `(${cashReqNodeNum}例)` : `(合同开始后${cashReqNodeNum}天)` : ''}` : '';
            }),
        }, {
            title: '合同约定请款金额/人民币(元)',
            dataIndex: 'remittanceAmount',
            key: 'remittanceAmount',
            width: 120,
            render: renderEnhancer(text => format('money', text)),
        }, {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            key: 'invoiceDate',
            width: 100,
            render: (text, record) => {
                const { rowSpan, markRed } = record;
                return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{format('date', text)}</span>;
            }
        }, {
            title: '到期日期',
            dataIndex: 'dueDate',
            key: 'dueDate',
            sorter: true,
            width: 100,
            render: (text, record) => {
                const { rowSpan, markRed } = record;
                return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{format('date', text)}</span>;
            }
        }];
        if (activeKey === '0') {
            columns.push({
                title: '距离到期天数',
                dataIndex: 'distanceDateInvoiceDay',
                key: 'distanceDateInvoiceDay',
                width: 100,
                render: (text, record) => {
                    const { rowSpan, markRed } = record;
                    return <span style={{ color:(rowSpan !== 1 || markRed === 1) && 'red'}}>{text}</span>;
                }
            });
        } else {
            columns.push({
                title: '超账龄',
                dataIndex: 'overDueDateDay',
                key: 'overDueDateDay',
                width: 80,
                render: (text, record) => {
                    const { rowSpan, markRed } = record;
                    return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{text}</span>;
                }
            });
        }
        columns.push({
            title: '发票金额(含税总额)总金额',
            dataIndex: 'invoiceMoney',
            key: 'invoiceMoney',
            width: 100,
            render: (text, record) => {
                const { rowSpan, markRed } = record;
                return <span style={{ color: (rowSpan !== 1 || markRed === 1) && 'red'}}>{format('money', text)}</span>;
            },
        });
        if (activeKey === '1') {
            columns.push({
                title: '超期原因',
                dataIndex: 'remark',
                key: 'remark',
                width: 160,
                render: renderEnhancer()
            });
        }
        return columns;
    }

    getDataSource = (data) => {
        const dataSource = [];
        (data || []).forEach(d => {
            const { records } = d;
            const list = records;
            const len = (list || []).length;
            if (len) {
                list.forEach((item, index) => {
                    const { invoiceDate, dueDate, distanceDateInvoiceDay, overAging, openAmount, invoiceBaName, contractBackRecordId } = item;
                    const setting = {};
                    if (invoiceBaName) {
                        setting.invoiceBaName = invoiceBaName;
                    }
                    dataSource.push({
                        ...d,
                        ...setting,
                        invoiceDate,
                        dueDate,
                        distanceDateInvoiceDay,
                        overDueDateDay: overAging,
                        invoiceMoney: openAmount,
                        rowSpan: index === 0 ? len : 0,
                        rowId: `${d.contractRemittanceApplicationId}-${contractBackRecordId}`
                    });
                });
            } else {
                dataSource.push({
                    ...d,
                    rowSpan: 1,
                    rowId: d.contractRemittanceApplicationId
                });
            }
        });
        return dataSource;
    }

    handleClick = (record) => {
        const { notice } = this.props;
        const { remittanceCode } = record;
        notice.saveParams({ remittanceCode });
        location.href = '/#/contractManagement/requestRecord';
    }
    
    handleChange = (params) => {
        this.props.onChange(params, true);
    }

    render() {
        const { height, pagination, sortParams } = this.props;
        const { data, loading } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    rowKey="rowId"
                    sortParams={sortParams}
                    pagination={pagination}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    className="invoicedUnreturned"
                />
            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/InvoicedUnreturned/TablePage/List.js